import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldDropdownNext = _resolveComponent("FieldDropdownNext")!

  return (_openBlock(), _createBlock(_component_FieldDropdownNext, {
    options: _ctx.options,
    loading: _ctx.loading,
    "show-clear": "",
    filter: ""
  }, null, 8, ["options", "loading"]))
}